module.exports = __webpack_public_path__ + "static/media/Button_Report-Player.21fa817b.png";